// FTC Türkiye Sitesi için Btpro tarafından yazılan scriptler

// Blog sayfalarının Mobil uygulamalarda(ios,android) web view olarak gezinirken header,footer,efilli ve insider popup gibi alanları gizleyen kod bloğudur.
document.addEventListener("DOMContentLoaded", function () {
    var isFlyingTiger = window.location.hostname === "www.flyingtiger.com.tr";
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    var isAndroidWebView = /Android.*; wv|Version\/[\d.]+.*Chrome\/[.0-9]* Mobile/i.test(userAgent);
    var isIOSWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(userAgent);

    if (isFlyingTiger && (isAndroidWebView || isIOSWebView)) {
        var header = document.querySelector("#header-announcement-container");
        var footer = document.querySelector("footer");
        var efilli = document.querySelector("efilli-layout-dynamic");

        if (header) header.style.display = "none";
        if (footer) footer.style.display = "none";
        if (efilli) efilli.style.display = "none";

        var observer = new MutationObserver(function (mutationsList) {
            mutationsList.forEach(function (mutation) {
                if (mutation.type === "childList") {
                    var modal = document.querySelector("#ins-frameless-overlay");
                    var insiderPopup = document.querySelector(".ins-preview-wrapper-555");

                    if (modal) modal.style.setProperty("display", "none", "important");
                    if (insiderPopup) insiderPopup.style.setProperty("display", "none", "important");
                }
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }
});